import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { Router } from '@angular/router';
import { AffiliateFormComponent } from '../../components/affiliate-form/affiliate-form.component';
import { SharedMaterialUIModule } from '@shared/modules/shared-material-ui.module';
import { CreateAffiliateRequest } from '../../affiliate.model';
import { AffiliateStore } from '../../affiliate.store';
import { LookupStore } from '@core/lookup/lookup.store';
import { AFFILIATE_LOOKUP_CODES } from '@core/lookup/lookup-codes';
import { SHARED_IMPORTS } from '../../../../shared/modules/shared-imports.module';
import { SHARED_UTILS } from '@shared/modules/shared-utils.module';

@Component({
  selector: 'app-affiliate-create-page',
  imports: [AffiliateFormComponent, ...SharedMaterialUIModule, ...SHARED_IMPORTS],
  templateUrl: './affiliate-create.page.html',
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class AffiliateCreatePage {
  private readonly router = inject(Router);
  protected readonly affiliateStore = inject(AffiliateStore);
  protected readonly lookupStore = inject(LookupStore);
  readonly sharedUtils = SHARED_UTILS();

  constructor() {
    this.lookupStore.load(AFFILIATE_LOOKUP_CODES);
  }

  protected onSubmit(request: CreateAffiliateRequest): void {
    this.affiliateStore.createAffiliate(request, () => {
      void this.router.navigate(['/affiliates']);
    });
  }
}
